import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header/Header';
import './LandingPage.css';

const LandingPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDiagramLoaded, setIsDiagramLoaded] = useState(false);

  const slides = [
    {
      title: "Driving Digital Transformation",
      subtitle: "Use Certificates as Building Blocks for Innovative Applications",
      description: "Discover high-quality certificate verification from a wide range of reputable sources, both government and private sector, through our platform."
    },
    {
      title: "Secure Academic Verification",
      subtitle: "Blockchain-Powered Certificate Authentication",
      description: "Revolutionary certificate verification system using IPFS technology, ensuring authenticity and preventing fraud in academic credentials."
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    setIsDiagramLoaded(true);
  }, []);

  return (
    <div className="landing-page">
      <Header />
      
      {/* Hero Section */}
      <section className="hero-section">
        {/* Background Image */}
        <div className="hero-background-image">
          <img src="/background.jpg" alt="" className="background-img" onError={(e) => {e.target.src='/mesh-gradient%202.webp'}} />
        </div>
        {/* Wave Background Overlay */}
        <div className="hero-wave-background">
          <img src="/hero-wave.svg" alt="" className="wave-image" />
        </div>
        <div className="hero-container">
          <div className="hero-content">
            {/* Left Side - Text Content */}
            <div className="hero-text">
              <div className="slide-indicators">
                <button 
                  className={`indicator ${currentSlide === 0 ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(0)}
                />
                <button 
                  className={`indicator ${currentSlide === 1 ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(1)}
                />
              </div>

              <div className="slide-content">
                <p className="hero-subtitle">{slides[currentSlide].subtitle}</p>
                <h1 className="hero-title">{slides[currentSlide].title}</h1>
                <p className="hero-description">{slides[currentSlide].description}</p>
              </div>

              <div className="hero-actions">
                <Link to="/check" className="btn-explore">
                  Explore →
                </Link>
                <Link to="/upload" className="btn-get-started">
                  Get Started →
                </Link>
                <Link to="/login" className="btn-login">
                  Login →
                </Link>
              </div>

              <div className="hero-navigation">
                <button 
                  className="nav-arrow nav-arrow-left"
                  onClick={() => setCurrentSlide((prev) => prev === 0 ? slides.length - 1 : prev - 1)}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button 
                  className="nav-arrow nav-arrow-right"
                  onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            {/* Right Side - Visual Diagram */}
            <div className="hero-visual">
              <div className={`diagram-container ${isDiagramLoaded ? 'loaded' : ''}`}>
                <div className="diagram">
                  {/* Central API Icon */}
                  <div className="central-icon">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                      <path d="M12 8L24 16L36 8L24 0L12 8Z" fill="#1e293b"/>
                      <path d="M12 16L24 24L36 16" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 24L24 32L36 24" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 32L24 40L36 32" stroke="#1e293b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>

                  {/* Sector Categories */}
                  <div className="sector education">
                    <div className="sector-icon">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M16 4L4 8L16 12L28 8L16 4Z" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M4 8V20L16 24L28 20V8" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 12V24" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span className="sector-label">EDUCATION</span>
                  </div>

                  <div className="sector technology">
                    <div className="sector-icon">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <rect x="4" y="8" width="24" height="16" rx="2" stroke="#FF6B35" strokeWidth="2"/>
                        <path d="M8 12H24" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M8 16H20" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M8 20H16" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <span className="sector-label">TECHNOLOGY</span>
                  </div>

                  <div className="sector healthcare">
                    <div className="sector-icon">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M16 4L20 8H28V16L24 20V28H8V20L4 16V8H12L16 4Z" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 12V20" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M12 16H20" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <span className="sector-label">HEALTHCARE</span>
                  </div>

                  <div className="sector finance">
                    <div className="sector-icon">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M16 4C9.373 4 4 9.373 4 16S9.373 28 16 28S28 22.627 28 16S22.627 4 16 4Z" stroke="#FF6B35" strokeWidth="2"/>
                        <path d="M16 8V16L20 20" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span className="sector-label">FINANCE</span>
                  </div>

                  {/* Connection Lines */}
                  <svg className="connection-lines" width="100%" height="100%" viewBox="0 0 400 400">
                    <defs>
                      <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#FF6B35" stopOpacity="0.6"/>
                        <stop offset="100%" stopColor="#1e293b" stopOpacity="0.6"/>
                      </linearGradient>
                    </defs>
                    <path d="M200 200 L120 120" stroke="url(#lineGradient)" strokeWidth="2" opacity="0.7"/>
                    <path d="M200 200 L280 120" stroke="url(#lineGradient)" strokeWidth="2" opacity="0.7"/>
                    <path d="M200 200 L120 280" stroke="url(#lineGradient)" strokeWidth="2" opacity="0.7"/>
                    <path d="M200 200 L280 280" stroke="url(#lineGradient)" strokeWidth="2" opacity="0.7"/>
                  </svg>

                  {/* Floating Icons */}
                  <div className="floating-icon icon-1">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10 2L12 8H18L13 12L15 18L10 14L5 18L7 12L2 8H8L10 2Z" fill="#1e293b"/>
                    </svg>
                  </div>
                  <div className="floating-icon icon-2">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="8" stroke="#FF6B35" strokeWidth="2"/>
                      <path d="M6 10H14" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M10 6V14" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div className="floating-icon icon-3">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <rect x="3" y="3" width="14" height="14" rx="2" stroke="#1e293b" strokeWidth="2"/>
                      <path d="M7 7H13" stroke="#1e293b" strokeWidth="2" strokeLinecap="round"/>
                      <path d="M7 10H11" stroke="#1e293b" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div className="floating-icon icon-4">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10 2L18 6V14L10 18L2 14V6L10 2Z" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stats-header">
            <p className="stats-subtitle">Stats</p>
            <h2 className="stats-title">Certificate platform you can rely on</h2>
          </div>
          
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 2L20 6H28V14L24 18V26H8V18L4 14V6H12L16 2Z" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">10,000+</h3>
                <p className="stat-label">Certificates Verified</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4C9.373 4 4 9.373 4 16S9.373 28 16 28S28 22.627 28 16S22.627 4 16 4Z" stroke="#FF6B35" strokeWidth="2"/>
                  <path d="M16 8V16L20 20" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">99.9%</h3>
                <p className="stat-label">Uptime</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">500+</h3>
                <p className="stat-label">Institutions</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 2C8.268 2 2 8.268 2 16S8.268 30 16 30S30 23.732 30 16S23.732 2 16 2Z" stroke="#FF6B35" strokeWidth="2"/>
                  <path d="M16 8V16L20 20" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">24/7</h3>
                <p className="stat-label">Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;